import React, { useEffect, useMemo, useState } from "react";
import AccountSettingSidebar from "./components/AccountSettingSidebar";

import SurveyListHeader from "../../../component/layout/MainHeader";
import Svg from "../../../component/Svg";
import Card from "../../../core/Card";
import style from "../../style.module.css";
import Input from "../../../core/Inputs/DefaultInput";
import SearchInput from "../../../core/Inputs/SearchInput";
import userIcon from "../../../assets/images/survey-image-4.png";


import * as Yup from 'yup';
import DataTable from "react-data-table-component";
import SurveyListSidebar from "../../../component/layout/MainSidebar";
import { Link } from "react-router-dom";
import {
  addUser,
  deleteUser,
  editUser,
  getUserList,
} from "../../../store/actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { addUserSchema, editUserSchema } from "../../../schema/User";
import NestedMenuToggle from "./NestedMenuToggle";

import { getLeads } from '../../../store/actions/analyticsActions';
import { getStages } from '../../../store/actions/variableAction';
import { userDetail } from '../../../store/actions/userActions';
import useVerifySurveyId from '../../../hooks/verifySurveyId';
import EmptyStateSettings from "./empty-state/EmptyStateSettings";


export default function UserPermissions() {
  //const { leadsData } = useSelector((state) => state.analyticsData)
  //const survey_id = useVerifySurveyId()

  // const handleSearch = (searchValue) => {
  //     const payload = {
  //         search: searchValue
  //     }
  //     dispatch(userDetail(payload))
  // }
  //Effects
  // useEffect(() => {
  //     if (survey_id) {
  //         const payload = {
  //             survey_id: survey_id,
  //             search: ""
  //         }
  //         dispatch(getLeads(payload))
  //         dispatch(getStages(payload))
  //     }
  // }, [survey_id])


  const dispatch = useDispatch();
  // const { roleData: roleList } = useSelector((state) => state.roleData);
  const {
    userData: userData,
    isAddingUser,
    isDeleteUser,
  } = useSelector((state) => state.userData);

  useEffect(() => {
    if (!isAddingUser) {
      let addUser = document.getElementById("addUserModal");
      let userModal = window.bootstrap.Modal.getOrCreateInstance(addUser);
      if (userModal && userModal._isShown) {
        userModal.hide();
        getUsers();
      }
    }
    if (isAddingUser) {
      let addUserSuccess = document.getElementById("addUserSuccess");
      let userSuccessModal =
        window.bootstrap.Modal.getOrCreateInstance(addUserSuccess);
      if (userSuccessModal && !userSuccessModal._isShown) {
        userSuccessModal.show();
      }
    }
  }, [isAddingUser]);

  useEffect(() => {
    if (!isDeleteUser) {
      let deleteUser = document.getElementById("deleteModal");
      let deleteUserModal =
        window.bootstrap.Modal.getOrCreateInstance(deleteUser);
      if (deleteUserModal && deleteUserModal._isShown) {
        deleteUserModal.hide();
        getUsers();
      }
    }
  }, [isDeleteUser]);

  const [isEdit, setIsEdit] = useState(false);
  const [editUserData, setEditUserData] = useState(null);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [serverParams, setServerParams] = useState({
    startingLimit: '',
    resultsPerPage: '',
    search: "",
  });

  const getUsers = async () => {
    dispatch(getUserList(serverParams));
  };

  const editDataById = (editData) => {
    setIsEdit(true);
    setEditUserData(editData);

    formik.setFieldValue("name", editData.name);
    formik.setFieldValue("email", editData.email);
    let addUser = document.getElementById("addUserModal");
    let userModal = window.bootstrap.Modal.getOrCreateInstance(addUser);
    if (userModal && !userModal._isShown) {
      userModal.show();
    }
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .trim()
      .email('This is not a valid email')
      .required('Email required')
      .test('valid-email', 'This is not a valid email', function (value) {
        if (!value) return true; // Allow empty email
        return !value.includes('/') && !value.includes('?');
      }),
    password: Yup.string()
      .required('Password is required')
      .min(6, 'Password must be at least 6 characters')
      .matches(/[!@#$%&*]/, 'Password must contain at least one special character')
      .matches(/[0-9]/, 'Password must contain at least one number')
      .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      roles: "",
    },
    //validationSchema: !isEdit ? addUserSchema : editUserSchema,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      delete values.roles;
      values.roles = [values.roles];
      if (isEdit) {
        values.user_id = editUserData.id;
        delete values.password;
        editUserApi(values);
      } else {
        addUserData(values);
      }
    },
    validateOnChange: true,
    onChange: (values) => {
      delete values.roles;
      values.roles = [values.roles];
    },
  });


  const addUserData = async (payload) => {
    dispatch(addUser(payload));
  };

  const editUserApi = async (payload) => {
    dispatch(editUser(payload));
  };

  const deleteUserData = async () => {
    let payload = { id: deleteUserId };
    dispatch(deleteUser(payload));
  };

  const columns = [
    {
      name: "Name",
      cell: (row) => (
        <>
          <div className="d-flex table-profile align-items-center">
            <div className="img-wrapper">
              {/* <img src={userIcon} alt="" /> */}
              <span>{row.name ? row.name.substring(0, 2).toUpperCase() : row.email.substring(0, 2).toUpperCase()}</span>
            </div>
            <div className="flex-grow-1 ps-3">
              <h5>{row.name}</h5>
              <p>{row.email}</p>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Status",
      cell: (row) => {
        let statusText;
        switch (row.is_active) {
          case 0:
            statusText = 'Invited';
            break;
          case 1:
            statusText = 'Active';
            break;
          default:
            statusText = 'Inactive';
            break;
        }
        return <div className="text-center w-100"><span class={`table-status ${statusText}`}>{statusText}</span></div>;
      }
    },
    {
      name: "Date created",
      cell: (row) => {
        const dateTimeParts = row.add_date_time.split(' '); // Split the string by space
        const datePart = dateTimeParts[0]; // Take the first part, which contains the date
        return <div className="text-center w-100">{datePart}</div>;

      }
    },

    {
      name: "Action",
      width: '100px',
      cell: (row) => (
        <>
          <div className="d-flex action-wrapper">
            {window.modulePermissions.M3.edit == 1 && (

              <a
                href="#"
                className="action-btn"
                onClick={() => {
                  editDataById(row);
                }}
                data-toggle="tooltip"
                data-placement="top"
                title="Edit User"
              >
                <Svg name="table-edit" />
              </a>
            )}
            {window.modulePermissions.M3.del == 1 && (
              <a
                data-bs-toggle="modal"
                data-bs-target="#deleteModal"
                className="action-btn"
                onClick={() => setDeleteUserId(row.id)}
                data-toggle="tooltip"
                data-placement="top"
                title="Delete User"
              >
                <Svg name="table-delete" />
              </a>
            )}
          </div>
        </>
      ),
    },
  ];

  useEffect(() => {
    getUsers();
  }, [serverParams]);

  const [searchText, setSearchText] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
        <SurveyListHeader />
        <div id="viewport" className="d-flex">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <AccountSettingSidebar />
            <div className="flex-grow-1 variable-pg-content">
              {/* breadcrumbs here */}
              <div className="custom-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link
                        to="/admin/roi"
                        className="home-item"
                        title="Dashboard"
                      >
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/profile">Settings</Link>
                    </li>
                    {/* <li className="breadcrumb-item">
                        <Link to="/admin/settings/user-permissions">
                          User & Teams
                        </Link>
                      </li> */}
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                    >
                      <strong>Users</strong>
                    </li>
                  </ol>
                </nav>
              </div>
              {/* breadcrumbs ends here */}
              <div className="survey-main-container">
                <div className="page-heading d-lg-none">
                  <div className="d-flex align-items-start">
                    <NestedMenuToggle />
                    <div className="flex-grow-1 ps-3 ps-lg-0">
                      <h1>Users</h1>
                    </div>
                  </div>
                </div>
                <div className="role-wrapper flex-grow-1">
                  <div className="pagesRow varPg">

                    <div className="page-heading heading-section-new mb-3">
                      <p>Manage product access for all the users in your organization.</p>
                    </div>

                    {/* Empty State of User Role */}
                    <div className="table-wrapper-view">
                      <div className="search-filter d-md-flex align-items-center">
                        <div className="flex-grow-1 pe-0 pe-md-3 mb-3 mb-md-0">
                          <SearchInput
                            id="searchInput" // Add an id to the search input for easier selection
                            className="custom-search-input"
                            //type="def"
                            view="outlined"
                            color="primary"
                            placeholder={searchText ? "" : "Search"} // Dynamically set the placeholder text
                            fill={true}
                            value={searchText} // Bind the value of the search input to the state variable
                            onChange={(e) => {
                              setSearchText(e.target.value)
                            }} // Update the search text state when the user types

                            //onChange={(e) => { handleSearch(e.target.value) }}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                setServerParams({
                                  ...serverParams,
                                  search: searchText, // Use searchText instead of e.target.value
                                });
                                setSearchText(searchText)
                              }
                            }}

                            onClick={(e) => {
                              setServerParams({
                                ...serverParams,
                                search: searchText, // Use searchText instead of e.target.value
                              });
                              setSearchText(searchText)
                            }}

                            onSearchIconClick={() => {
                              // Implement your search logic here
                              setServerParams({
                                ...serverParams,
                                search: searchText,
                              });
                            }}


                            onClear={() => {
                              setSearchText(""); // Clear the search text state when the search field is cleared
                              setServerParams({
                                ...serverParams,
                                search: "",
                              });
                            }}
                          />

                          {userData.length === 0 && (
                            <div className="no-records text-center">There are no records to display</div>
                          )}
                        </div>

                        {window.modulePermissions.M3.add == 1 && (
                          <div className="button-wrap">
                            <button
                              type="button"
                              className="btn btn-primary add-btn"
                              data-bs-toggle="modal"
                              data-bs-target="#addUserModal"
                              onClick={() => {
                                setIsEdit(false);
                                setEditUserData(null);
                                formik.resetForm();
                              }}
                            >
                              <Svg name="plus" /> Create{" "}
                            </button>
                          </div>
                        )}

                      </div>
                      <div className="table-responsive survey-table">
                        <div className="table-wrap custom-data-table no-width">
                          {/* Add Empty State for User Role */}
                          {/* <EmptyStateSettings /> */}


                          {userData.length > 0 && (
                            // <DataTable
                            //   columns={columns}
                            //   data={userData}
                            //   //selectableRows
                            //   // onSelectedRowsChange={handleRowSelected}
                            //   // clearSelectedRows={toggleCleared}
                            //   pagination
                            // // paginationComponent={(props) => {
                            // //   return (
                            // //     <Pagination
                            // //       currentPage={currentPage}
                            // //       totalPage={2}
                            // //       gotoPreviousPage={gotoPreviousPage}
                            // //       changePage={changePage}
                            // //       geToNextPage={geToNextPage}
                            // //     />
                            // //   );
                            // // }}
                            // />

                            <DataTable
                              columns={columns}
                              data={userData}
                              pagination

                            />


                          )}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal fade setting-modal"
        id="addUserModal"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer"}>
                <div
                  className={
                    "formvawrapper modal-setting-medium" + " " + style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-12px" + " " + style.card}
                  >
                    <div className="modal-heading">
                      <h4>{isEdit ? "Edit" : "Add new"} user</h4>
                    </div>
                    <form onSubmit={formik.handleSubmit} onClick={formik.handleChange}>
                      <div className="form-wrapper">
                        <div className="row">
                          <div className="col-12 position-relative">
                            <div className="form-group mb-3">
                              <label>Full name</label>
                              <Input
                                type="text"
                                view="outlined"
                                dense={false}
                                color="default"
                                name="name"
                                autoComplete="off"
                                label=""
                                placeholder="Enter full name..."
                                clearButton={true}
                                success={false}
                                error={false}
                                fill={true}
                                errorHelperText={null}
                                className={"formsinput"}
                                onChange={formik.handleChange}
                                value={formik.values.name}
                                maxLength={100}
                              />
                              {/* <p className="help-text">
                              You can add or invite upto 10 people at a time
                            </p> */}
                            </div>
                            {formik.errors.name && formik.touched.name && (
                              <div className="validation-msg">
                                {formik.errors.name}
                              </div>
                            )}
                          </div>
                          {/* <div className="col-auto">
                          <div className="or-text">Or</div>
                        </div> */}
                          <div className="col-12 position-relative">
                            <div className="form-group mb-3">
                              <label>Email address</label>
                              <Input
                                type="email"
                                view="outlined"
                                autoComplete="off"
                                dense={false}
                                color="default"
                                label=""
                                placeholder="Enter email address..."
                                clearButton={true}
                                // success={false}
                                // error={false}
                                fill={true}
                                // errorHelperText={null}
                                success={!formik.errors.email && formik.touched.email}
                                //error={formik.errors.email && formik.touched.email}
                                errorHelperText={formik.errors.email}

                                // success={!formik.errors.email && formik.touched.email}
                                // error={formik.errors.email && formik.touched.email}
                                // errorHelperText={formik.errors.email}

                                className={"formsinput"}
                                name="email"
                                onChange={formik.handleChange}
                                value={formik.values.email}
                              />
                              {formik.errors.email && formik.touched.email && (
                                <div className="validation-msg">
                                  {formik.errors.email}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-12 position-relative">
                            <div className="form-group mb-3">
                              <label>Password</label>
                              <Input
                                type={showPassword ? "text" : "password"}
                                view="outlined"
                                autoComplete="off"
                                dense={false}
                                color="default"
                                label=""
                                placeholder="Enter password..."
                                // clearButton={true}
                                // success={false}
                                // error={false}
                                fill={true}
                                // errorHelperText={null}
                                className={"formsinput"}
                                name="password"
                                onChange={formik.handleChange}
                                //success={!formik.errors.password && formik.touched.password} // Update success prop
                                // error={formik.errors.password && formik.touched.password} // Update error prop
                                errorHelperText={formik.errors.password} // Show error message if there's an error
                                value={formik.values.password}
                              />
                              <span
                                className={`forgot-wrap`} style={{ top: '45px' }}
                                onClick={handleTogglePasswordVisibility}
                              ><i className={`${showPassword ? "fa fa-eye-slash" : "fa fa-eye"}`}></i>
                              </span>
                              {formik.errors.password &&
                                formik.touched.password && (
                                  <div className="validation-msg">
                                    {formik.errors.password}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>

                        {/* <div className="permission-wrapper-outer form-group mb-3 d-none">
                          <label>Permissions</label>
                          <div className="permission-wrapper">
                            {roleList?.map((role, key) => {
                              return (
                                <div className="check-wrap" key={key}>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      name="roles"
                                      type="radio"
                                      id={role?.id}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "roles",
                                          e.target.id
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={role?.id}
                                    >
                                      {role?.role_name}
                                    </label>
                                  </div>
                                </div>
                              );
                            })} */}
                        {/* <div className="row">

                            <div className="col-lg-3 mb-3">
                              <div className="check-wrap">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="UserPermissionAdmin"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="UserPermissionAdmin"
                                  >
                                    Admin
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-3 mb-3">
                              <div className="check-wrap">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="UserPermissionSurveyAdmin"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="UserPermissionSurveyAdmin"
                                  >
                                    Survey admin
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-3 mb-3">
                              <div className="check-wrap">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="UserPermissionRead"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="UserPermissionRead"
                                  >
                                    Read
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-3 mb-3">
                              <div className="check-wrap">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="UserPermissionWrite"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="UserPermissionWrite"
                                  >
                                    Write
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div> */}
                        {/* </div>
                        </div> */}
                      </div>

                      <div className="button-wrap d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-bordered color-cancel"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setIsEdit(false);
                            setEditUserData(null);
                            formik.resetForm();
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary add-btn ms-3"
                        // data-bs-dismiss="modal"
                        // data-bs-toggle="modal"
                        // data-bs-target="#addUserSuccess"
                        >
                          {/* <Svg name="plus" /> */}
                          Save
                          {/* {isEdit ? "Edit" : "Add"} User */}
                        </button>
                      </div>
                    </form>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal fade setting-modal"
        id="addUserSuccess"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper modal-setting-medium" + " " + style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-12px" + " " + style.card}
                  >
                    <div className="modal-success">
                      <div className="icon-wrap">
                        <svg
                          width={220}
                          height={220}
                          viewBox="0 0 220 220"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx={110} cy={110} r={110} fill="#16C79A" />
                          <path
                            d="M74 124.573L91.567 142L146 88"
                            stroke="white"
                            strokeWidth={9}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="text-wrap">
                        <h4>User {isEdit ? "updated" : "added"}</h4>
                        <p>
                          {isEdit ? "" : "New"} user has been{" "}
                          {isEdit ? "updated" : "added"} Successfully
                        </p>
                      </div>
                      <div className="button-wrap">
                        <button
                          type="button"
                          className="btn btn-primary add-btn"
                          data-bs-dismiss="modal"
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal custom-modal fade deleteModal"
        id="deleteModal"
        tabIndex={-1}
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper delete-modal-wrap modal-setting-medium" +
                    " " +
                    style.wrapper
                  }
                >
                  <Card
                    view="raised"
                    className={"formstyle p-0" + " " + style.card}
                  >
                    <div className="delete-body-wrap delete-language">
                      <div className="heading">
                        <h3>Delete users</h3>
                        <p>
                          Are you sure you want to delete these users
                          permanently?{" "}
                        </p>
                      </div>
                      <div className="warning-message">
                        <div className="title d-flex align-items-center">
                          <svg
                            width={40}
                            height={42}
                            viewBox="0 0 40 42"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20 2L37.3205 32H2.67949L20 2Z"
                              stroke="#F05454"
                              strokeWidth={3}
                              strokeLinejoin="round"
                            />
                            <path
                              d="M20 13.5385V22"
                              stroke="#F05454"
                              strokeWidth={3}
                            />
                            <circle
                              cx="19.9994"
                              cy="25.8461"
                              r={1}
                              fill="black"
                              stroke="#F05454"
                              strokeWidth="1.07692"
                            />
                          </svg>
                          <h4>Warning</h4>
                        </div>
                        <p>
                          By deleting the users you will be deleting the users
                          from all the Surveys and their permission to access.
                        </p>
                      </div>

                      <div className="button-wrap d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-bordered color-cancel"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary ms-3"
                          onClick={() => deleteUserData()}
                        >
                          Confirm delete
                        </button>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
